import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-requests-details-modal__container" }
const _hoisted_2 = {
  key: 0,
  class: "container__state"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "state__message" }, "Загрузка данных...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "state__message message--error" }, "При получении данных произошла ошибка", -1)
const _hoisted_5 = {
  key: 1,
  class: "container__content"
}
const _hoisted_6 = { class: "content__header" }
const _hoisted_7 = { class: "header__main" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "main__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10 9H8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 13H8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 17H8" })
], -1)
const _hoisted_9 = { class: "content__title" }
const _hoisted_10 = { class: "content__cheap" }
const _hoisted_11 = { class: "content__general" }
const _hoisted_12 = { class: "general__column" }
const _hoisted_13 = { class: "column__row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8 2v4" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 2v4" }),
    /*#__PURE__*/_createElementVNode("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "4",
      rx: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M3 10h18" })
  ]),
  /*#__PURE__*/_createTextVNode(" Дата: ")
], -1)
const _hoisted_15 = { class: "row__value" }
const _hoisted_16 = { class: "column__row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "12 6 12 12 16 14" })
  ]),
  /*#__PURE__*/_createTextVNode(" Время: ")
], -1)
const _hoisted_18 = { class: "row__value" }
const _hoisted_19 = { class: "column__row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Водитель: ")
], -1)
const _hoisted_21 = { class: "row__value" }
const _hoisted_22 = { class: "column__row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "12",
      x: "2",
      y: "6",
      rx: "2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M6 12h.01M18 12h.01" })
  ]),
  /*#__PURE__*/_createTextVNode(" Тип расчёта: ")
], -1)
const _hoisted_24 = { class: "row__value" }
const _hoisted_25 = { class: "general__column" }
const _hoisted_26 = { class: "column__row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M15 18H9" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "18",
      r: "2"
    }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "7",
      cy: "18",
      r: "2"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Перевозчик: ")
], -1)
const _hoisted_28 = { class: "row__value" }
const _hoisted_29 = { class: "column__row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M10 9H8" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 13H8" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M16 17H8" })
  ]),
  /*#__PURE__*/_createTextVNode(" ИИН/БИН: ")
], -1)
const _hoisted_31 = { class: "row__value" }
const _hoisted_32 = { class: "column__row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "7",
      r: "4"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Получатель: ")
], -1)
const _hoisted_34 = { class: "row__value" }
const _hoisted_35 = { class: "column__row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Телефон: ")
], -1)
const _hoisted_37 = { class: "row__value" }
const _hoisted_38 = {
  key: 2,
  class: "container__content"
}
const _hoisted_39 = { class: "content__header" }
const _hoisted_40 = { class: "header__main" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("svg", {
  class: "main__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10 9H8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 13H8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 17H8" })
], -1)
const _hoisted_42 = { class: "content__title" }
const _hoisted_43 = { class: "content__cheap" }
const _hoisted_44 = { class: "content__general" }
const _hoisted_45 = { class: "general__column" }
const _hoisted_46 = { class: "column__row row--column" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, " Перевозчик ", -1)
const _hoisted_48 = { class: "row__value" }
const _hoisted_49 = { class: "column__row row--column" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, " Дата начала ", -1)
const _hoisted_51 = { class: "row__value" }
const _hoisted_52 = { class: "general__column" }
const _hoisted_53 = { class: "column__row row--column" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, " Водитель ", -1)
const _hoisted_55 = { class: "row__value" }
const _hoisted_56 = { class: "row__label" }
const _hoisted_57 = { class: "column__row row--column" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "row__label" }, " Дата окончания ", -1)
const _hoisted_59 = { class: "row__value" }
const _hoisted_60 = { class: "content__ftl-payment" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "ftl-payment__title" }, "Перечисление на счёт", -1)
const _hoisted_62 = { class: "ftl-payment__container" }
const _hoisted_63 = { class: "container__row grid-cols-2" }
const _hoisted_64 = { class: "row__column" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "column__label" }, "ФИО", -1)
const _hoisted_66 = { class: "column__value" }
const _hoisted_67 = { class: "row__column" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "column__label" }, "Номер", -1)
const _hoisted_69 = { class: "column__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_status = _resolveComponent("bs-status")!
  const _component_bs_divider = _resolveComponent("bs-divider")!
  const _component_prices = _resolveComponent("prices")!
  const _component_pay = _resolveComponent("pay")!
  const _component_history = _resolveComponent("history")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createBlock(_component_bs_modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.state.isLoading || _ctx.state.isFailed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.state.isLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3,
                    _createVNode(_component_bs_loader)
                  ], 64))
                : (_ctx.state.isFailed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_4,
                      _createVNode(_component_bs_button, {
                        color: "royal-blue",
                        onClick: _ctx.loadData
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : (_ctx.state.details && _ctx.paymentRequest)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, "Путевой лист " + _toDisplayString(_ctx.state.details.codeOneC), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.paymentRequest.clientType), 1)
                  ]),
                  (_ctx.paymentRequest.status)
                    ? (_openBlock(), _createBlock(_component_bs_status, {
                        key: 0,
                        color: _ctx.getColor()
                      }, {
                        default: _withCtx(() => [
                          (_ctx.paymentRequest.status.id === 60)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Оплачен")
                              ], 64))
                            : (_ctx.paymentRequest.status.id === 61)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Отказ от оплаты")
                                ], 64))
                              : (_ctx.paymentRequest.status.id === 62)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode("Ожидает оплаты")
                                  ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["color"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.paymentRequest.createdAt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatTimeFromISO(_ctx.state.details.workStartTime)) + " — " + _toDisplayString(_ctx.formatTimeFromISO(_ctx.state.details.workEndTime)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        (_ctx.state.details.courier)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.details.courier.fullName), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" — ")
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.state.details.calculationType) + " (" + _toDisplayString(_ctx.state.details.displayAmount) + ") ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        (_ctx.state.details.company)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.details.company.shortName), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" — ")
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.state.details.company)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.details.company.bin), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" — ")
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.state.details && _ctx.state.details.waybillPayment)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.details.waybillPayment.receiverFullName), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" — ")
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        (_ctx.state.details && _ctx.state.details.waybillPayment)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.state.details.waybillPayment.number), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" — ")
                            ], 64))
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_bs_divider, { horizontal: "" }),
                (_ctx.paymentRequest && _ctx.state.details)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_prices, {
                        "payment-request": _ctx.paymentRequest,
                        waybill: _ctx.state.details
                      }, null, 8, ["payment-request", "waybill"]),
                      _createVNode(_component_pay, {
                        "payment-request": _ctx.paymentRequest,
                        waybill: _ctx.state.details,
                        onPay: _ctx.onPay,
                        onDecline: _ctx.onDecline
                      }, null, 8, ["payment-request", "waybill", "onPay", "onDecline"]),
                      _createVNode(_component_history, {
                        "payment-request": _ctx.paymentRequest,
                        waybill: _ctx.state.details
                      }, null, 8, ["payment-request", "waybill"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.state.ftlOrder && _ctx.paymentRequest)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.state.ftlOrder.id), 1),
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.paymentRequest.clientType), 1)
                    ]),
                    (_ctx.paymentRequest.status)
                      ? (_openBlock(), _createBlock(_component_bs_status, {
                          key: 0,
                          color: _ctx.getColor()
                        }, {
                          default: _withCtx(() => [
                            (_ctx.paymentRequest.status.id === 60)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Оплачен")
                                ], 64))
                              : (_ctx.paymentRequest.status.id === 61)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode("Отказ от оплаты")
                                  ], 64))
                                : (_ctx.paymentRequest.status.id === 62)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createTextVNode("Ожидает оплаты")
                                    ], 64))
                                  : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["color"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.state.ftlOrder.carrier_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.formatDate(_ctx.state.ftlOrder.take_date, { withTime: false })) + " " + _toDisplayString(_ctx.state.ftlOrder.take_time), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.state.ftlOrder.driver_name), 1),
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.state.ftlOrder.driver_phone), 1)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.formatDate(_ctx.state.ftlOrder.delivery_date)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.paymentRequest.receiverFullName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.paymentRequest.number), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(_component_bs_divider, { horizontal: "" }),
                  (_ctx.paymentRequest && _ctx.state.ftlOrder)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_prices, {
                          "payment-request": _ctx.paymentRequest,
                          waybill: _ctx.state.details,
                          "ftl-order": _ctx.state.ftlOrder
                        }, null, 8, ["payment-request", "waybill", "ftl-order"]),
                        _createVNode(_component_pay, {
                          "payment-request": _ctx.paymentRequest,
                          onPay: _ctx.onPay,
                          onDecline: _ctx.onDecline
                        }, null, 8, ["payment-request", "onPay", "onDecline"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "onClose"]))
}